import { render, staticRenderFns } from "./Demo.vue?vue&type=template&id=2aeb1380&scoped=true&"
import script from "./Demo.vue?vue&type=script&lang=ts&"
export * from "./Demo.vue?vue&type=script&lang=ts&"
import style0 from "./Demo.vue?vue&type=style&index=0&id=2aeb1380&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeb1380",
  null
  
)

export default component.exports